<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="goToManageResellerSales()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                {{ mode === 0 ? 'Add Reseller Sales' : (mode === 2 ? 'View Reseller Sales' : 'Edit Reseller Sales') }}
            </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form" (ngSubmit)="onsubmit()">
            <div class="row d-felx justify-content-center">
                <div class="col-sm-4 col-md-4 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Reseller</mat-label>
                        <mat-select class="scrollbarcs" formControlName="resellerId"
                            (selectionChange)="onResellerChange($event)" placeholder="Please select Reseller">
                            <mat-select-filter [displayMember]="'value'" [array]="filterRoleList"
                                (filteredReturn)="resellerList = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of resellerList" [value]="item.id"
                                style="overflow-y: scroll !important;">
                                {{item.resellerName}} - {{item.resellerCode}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4 col-md-4 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Reseller Sales Name</mat-label>
                        <input matInput maxlength="100" formControlName="resellerSalesName"
                            placeholder="Enter Reseller Sales Name" required class="col-12" autocomplete="off"
                            appOnlyalphabet>
                    </mat-form-field>
                </div>
                <div class="col-sm-4 col-md-4 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Reseller Sales Code</mat-label>
                        <input matInput formControlName="resellerSalesCode" placeholder="Enter Reseller Sales Code"
                            required [readonly]="mode !== 0" maxlength="50" class="col-12" autocomplete="off">
                    </mat-form-field>
                </div>
            </div>


            <div class="row" *ngIf="mode === 0 || mode === 1">
                <div class="col-sm-12 col-md-5 mt-4" style="margin-left: 3rem;margin-top: 2rem !important;">
                    <mat-checkbox style="transform: scale(1.3);" color="primary" class="prepaid-checkbox"
                        formControlName="presentInPrepaid">
                        {{ mode === 0 ? 'Add Reseller details in Prepaid portal' :
                        (mode === 1 ? 'Update Reseller details in Prepaid portal' :
                        'Reseller details in Prepaid portal') }}

                    </mat-checkbox>
                </div>
            </div>

            <div class="d-flex justify-content-center button-style" *ngIf="!isViewMode">
                <button type="submit" class="btn btn-secondary mb-3 mt-5" matButton> Save</button>
            </div>
        </form>
    </div>
</div>